module.exports = "<footer class=\"app-footer\">\n  <span><a href={{link}}>EVEx</a> &copy; 2020.</span>\n</footer>\n"